import React, { useEffect, useState } from "react";
import { ArrowUp } from "../Icons";

const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isNearBottom, setIsNearBottom] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 769);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const container = document.body;

        const handleScroll = () => {
            const scrollTop = container.scrollTop;
            const windowHeight = window.innerHeight;

            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.body.clientHeight,
                document.documentElement.clientHeight
            );

            const nearBottom = scrollTop + windowHeight >= documentHeight - 100;
            setIsNearBottom(nearBottom);

            if (scrollTop > 200) {
                if (!isVisible)
                    setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            onClick={scrollToTop}
            style={{
                ...{
                    position: 'fixed',
                    bottom: isNearBottom ? (isMobile ? '430px' : '200px') : '40px',
                    right: '40px',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: '#ffffffff',
                    // color: '#fff',
                    border: 'none',
                    cursor: 'pointer',
                    zIndex: 1000,
                    boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                },
                display: isVisible ? 'block' : 'none'
            }}
            aria-label="Scroll to top"
        >
            <ArrowUp
                width={20}
                height={20}
            />
        </button>
    );
};

export default BackToTopButton;